import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.find";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapMutations } from 'vuex';
import NiotaClassicApiService from '../../../services/niotaClassicApiService';
import EditMixin from '../../../components/core/dtwin/editMixin';
import GeoDataMixin from '../../../components/core/dtwin/geoDataMixin';
import deviceMixin from '../../../components/is/assetMgmt/deviceMixin';
import get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
import mixinActionBoxStyles from '../../../components/core/mixinActionBoxStyles';
export default {
  name: 'ViewISAssetMgmtDetails',
  mixins: [EditMixin, GeoDataMixin, deviceMixin, mixinActionBoxStyles],
  data: function data() {
    return {
      twinSelectionTreeMenu: true,
      pageYOffset: 0,
      tabItem: this.$route.query.stateId ? 'tab-states' : this.$route.query.ruleId ? 'tab-rules' : 'tab-dashboard',
      shouldOpenStateDetail: !!this.$route.query.stateId
    };
  },
  computed: {
    headerBG: function headerBG() {
      if (get(this.twinObject, 'data.twinImageId')) {
        return "".concat(process.env.VUE_APP_API_HOST).concat(process.env.VUE_APP_API_PATH, "/upload/").concat(this.twinObject.data.twinImageId);
      }

      return './img/dtwin-factory1.png';
    },
    isMobile: function isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    operationalStatus: function operationalStatus() {
      return {
        0: this.$i18n_t('NiotaClassic.Devices.form.unset'),
        1: this.$i18n_t('NiotaClassic.Devices.form.inTransit'),
        2: this.$i18n_t('NiotaClassic.Devices.form.readyForOperation'),
        3: this.$i18n_t('NiotaClassic.Devices.form.inOperation'),
        4: this.$i18n_t('NiotaClassic.Devices.form.temporaryInactive'),
        5: this.$i18n_t('NiotaClassic.Devices.form.decommissioned')
      };
    },
    operationalStatusItems: function operationalStatusItems() {
      var _this = this;

      return Object.keys(this.operationalStatus).map(function (status) {
        return {
          text: _this.operationalStatus[status],
          value: status
        };
      });
    }
  },
  watch: {
    twinDataStates: function twinDataStates() {
      if (this.twinDataStates.length) {
        if (this.shouldOpenStateDetail && this.$refs['stateTable']) {
          this.finishedLoadingStatesTable();
        }
      }

      this.setupAssetDevice();
      this.twinObject = cloneDeep(this.twinObject);
    },
    $route: function $route() {
      // the component is not reloaded/re-mounted if the twin-id in the route changes
      // so perform the setup again for a different route; i.e. swap out the displayed details on-the-fly
      this.teardownDtwinSocket();
      this.setup();

      if (get(this.$route, 'query.stateId')) {
        this.tabItem = 'tab-states';
      } else if (get(this.$route, 'query.ruleId')) {
        this.tabItem = 'tab-rules';
      }
    },
    deviceData: function deviceData() {
      var _this2 = this;

      this.deviceData.forEach(function (device, i) {
        _this2.fetchBatteryInformation(i);
      });
    }
  },
  mounted: function mounted() {
    this.baseLink = 'is-assetmgmt/assets';
    window.addEventListener('scroll', this.saveScrollOffset);
    this.setup();
    this.setupAssetDevice();
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.saveScrollOffset);
  },
  methods: _objectSpread(_objectSpread({}, mapMutations('app', ['snackbar'])), {}, {
    setupAssetDevice: function setupAssetDevice() {
      var deviceId = // prefer the hardwired device-id
      get(this.twinObject, 'data.assetManagement.deviceIds[0]') || // otherwise get the first iothub-identifier
      get(this.twinDataStates.filter(function (state) {
        return get(state, 'properties.binding.type') === 'iothub';
      }), '[0].properties.binding.options.identifier') || null;

      if (deviceId) {
        this.setupAssetTwin([deviceId]);
      }
    },
    digitalTwinChanged: function digitalTwinChanged(selection) {
      if (parseInt(selection.id) !== parseInt(this.$route.params.id)) {
        this.$router.push("/is-assetmgmt/assets/".concat(selection.id));
      }

      this.twinSelectionTreeMenu = false;
    },
    breadCrumbsPath: function breadCrumbsPath() {
      var ancestorList = this.ancestorList();

      if (ancestorList.length) {
        return ancestorList.map(function (a) {
          return {
            to: "/digitaltwin-mgmt/".concat(a.id),
            text: a.title
          };
        });
      }

      return [{
        to: '/is-assetmgmt/',
        text: this.$i18n_t('IS.AssetMgmt.drawer.isAssetMgmtList')
      }];
    },
    saveScrollOffset: function saveScrollOffset() {
      this.pageYOffset = window.pageYOffset;
    },
    finishedLoadingStatesTable: function finishedLoadingStatesTable() {
      var _this3 = this;

      if (this.$route.query.stateId) {
        this.$nextTick(function () {
          var state = _this3.twinDataStates.find(function (s) {
            return s.id === parseInt(_this3.$route.query.stateId);
          });

          if (state) {
            _this3.shouldOpenStateDetail = false;

            _this3.$refs['stateTable'].editState(state);
          }
        });
      }
    },
    didUpdateStates: function didUpdateStates() {
      this.refreshStates();
    },
    dialogDisable: function dialogDisable() {
      this.dtwinToggleState();
    },
    prepareSubmit: function prepareSubmit() {
      this.twinObject.data.assetManagement.deviceIds = this.deviceData.map(function (d) {
        return d.deviceId;
      });
      this.handleSubmit();
    },
    fetchBatteryInformation: function fetchBatteryInformation(index) {
      var _this4 = this;

      if (this.deviceData[index].batteryLevel === undefined && get(this.deviceData[index], 'deviceType.properties.battery_level')) {
        NiotaClassicApiService.deviceFetchPackets(this.deviceData[index].deviceId, 0, 0).then(function (res) {
          if (get(res, 'data.packets[0].source_data')) {
            _this4.setLastBatteryLevel(get(res, 'data.packets[0].source_data'), index);
          }
        }).catch(function () {
          _this4.devicePackets = [];
        });
      }
    },
    setLastBatteryLevel: function setLastBatteryLevel(sourceData, index) {
      // clone, in order to avoid the original array being modified
      var devData = cloneDeep(this.deviceData);
      var batteryLevelVariable = get(devData, "[".concat(index, "]deviceType.properties.battery_level.variable"));

      if (sourceData.parsed && batteryLevelVariable) {
        devData[index].batteryLevel = sourceData.parsed[batteryLevelVariable];

        if (devData[index].batteryLevel === undefined) {
          // do not create endless fetch loops
          devData[index].batteryLevel = null;
        }

        this.deviceData = cloneDeep(devData);
      }
    },
    getBatteryLevel: function getBatteryLevel(deviceData) {
      var text = '';

      if (deviceData.batteryLevel || deviceData.batteryLevel === 0) {
        text = deviceData.batteryLevel;
      }

      var valueType = get(deviceData, 'deviceType.properties.battery_level.value_type_name');

      if (valueType) {
        text += valueType;
      }

      return text;
    }
  })
};